import { Event as GlobalEvent } from "../../Global/Base/Events";
import { GenericControl } from "../UI.BaseControls/GenericControl";
import { EventHelper } from "../UI.BaseControls/Helpers/EventHelper";
import { createElement, registerCustomElement } from "../UI.ElementarControls/Utils/CustomElementUtils";
import { FileEditStatus } from "../UI/UI/FileMenu";
import { SimpleFileEditElement } from "./SimpleFileEditElement";

/**
 * K simplefileeditelementu přidává tlačítko křížek pro smazání
 */
export class CrossFileEditElement extends SimpleFileEditElement {
    public readonly removeButtonClicked: GlobalEvent<CrossFileEditElement, void> = new GlobalEvent<CrossFileEditElement, void>();

    private _removeButton: HTMLButtonElement;

    //#region Properties
    public set file(f: File) {
        this._files = [f];
        if (f != null)
            this.fileName = f.name;
        else
            this.fileName = null;
    }
    //#endregion Properties

    constructor(_self?: any) {
        super();
    }

    protected override _constructor(setStatus: boolean = false): void {
        super._constructor(setStatus);
        this.classList.add("CrossFileEditElement");
        this._removeButton = createElement({ type: "button", classes: ["item-icon", "icon", "ui-cross-small", "flat", "btn"] }) as HTMLButtonElement;
        this._removeButton.style.visibility = "hidden";
        this._innerContent.insertBefore(this._removeButton, this._innerContent.lastChild);
    }

    public override setStatus(status: FileEditStatus): boolean {
        if (!super.setStatus(status))
            return false;

        if (this.status === FileEditStatus.uploading)
            this._removeButton.style.visibility = "hidden";
        else
            this._removeButton.style.visibility = "visible";

        return true;
    }

    protected override connectedCallbackSpecial(): void {
        super.connectedCallbackSpecial();
        GenericControl.registerEventListener(this._removeButton, "click", (e: Event) => {
            EventHelper.stopPropagation(e);
            this.callEvent("removeRequest");
            this.removeButtonClicked.trigger(this);
        });
    }

    protected override disconnectedCallback(): void {
        super.disconnectedCallback();
        GenericControl.unregisterEventListener(this._removeButton);
    }

    public async callUploadRequest(): Promise<boolean> {
        const isValid: boolean = await this._handleFiles(this._files as unknown as FileList);
        if (isValid)
            this.callEvent("uploadRequest", { files: this._files });
        return isValid;
    }

    //#enregion Zpracování metod z globální třídy GenericControl
}

registerCustomElement("tsc-CrossFileEdit", CrossFileEditElement);
